import { makeVar, useReactiveVar } from "@apollo/client";

export const selectedCustomerVariable = makeVar<string>("");

export const useSelectedCustomerId = () =>
  useReactiveVar(selectedCustomerVariable);
